import type { PackageReference, TriggerResource } from "@octopusdeploy/octopus-server-client";
import React, { useMemo, useState } from "react";
import type { RelatedTriggersDependencies } from "./CalloutReferencedPackageTriggerConnections";
import { MultipleRelatedTriggersModifiedCallout, SingleRelatedTriggerModifiedCallout } from "./RelatedTriggerCallouts";
import { getRelatedTriggersForReferencedPackages, getPackageNamesUsedInTriggers } from "./triggerPackageRelations";
interface CalloutModifiedTriggerConnectionsProps {
    dependencies: RelatedTriggersDependencies;
    packageReferences: PackageReference[];
    modelDirty: boolean;
}
export function CalloutModifiedTriggerConnections({ dependencies, packageReferences, modelDirty }: CalloutModifiedTriggerConnectionsProps) {
    const [originalPackageNames, setOriginalPackageNames] = useState<string[]>([]);
    const [originalTriggers, setOriginalTriggers] = useState<TriggerResource[]>([]);
    const { spaceId, projectSlug } = dependencies;
    const relatedTriggers = useMemo(() => getRelatedTriggersForReferencedPackages(dependencies, packageReferences), [dependencies, packageReferences]);
    const packageNames = getPackageNamesUsedInTriggers(relatedTriggers, packageReferences);
    const uniqueTriggerCount = [...new Set(relatedTriggers.map((trigger) => trigger.Id))].length;
    if (originalPackageNames.length === 0 && packageNames.length !== 0) {
        // Can't re-use packageNames as it only uses the first element for some reason
        setOriginalPackageNames(getPackageNamesUsedInTriggers(relatedTriggers, packageReferences));
    }
    if (originalTriggers.length === 0 && relatedTriggers.length !== 0) {
        setOriginalTriggers(relatedTriggers);
    }
    // We should never show a warning if there wasn't an existing related trigger
    if (originalTriggers.length === 0 || originalPackageNames.length === 0)
        return <></>;
    const changedPackageNames = originalPackageNames.filter((name) => !packageNames.includes(name));
    if (changedPackageNames.length > 0) {
        if (uniqueTriggerCount === 1) {
            const triggerId = relatedTriggers[0].Id;
            return <SingleRelatedTriggerModifiedCallout triggerId={triggerId} spaceId={spaceId} projectSlug={projectSlug} disableLink={modelDirty}/>;
        }
        else {
            return <MultipleRelatedTriggersModifiedCallout spaceId={spaceId} projectSlug={projectSlug} disableLink={modelDirty}/>;
        }
    }
    return <></>;
}
